import React from 'react';
import { Switch, Route } from 'react-router-dom';

//Styles
import './App.css';

// Layouts
import HomepageLayout from './layouts/HomepageLayouts';
import MainLayout from './layouts/MainLayouts';

// Pages
import Homepage from './pages/Homepage';
import CreditPage from './pages/Creditspage';
import AboutPage from './pages/Aboutpage';
import MainPage from './pages/Mainpage';
import FaucetPage from './pages/FaucetPage';
import CloudminingPage from './pages/CloudminingPage';
import TradingPage from './pages/TradingPage';
import MobileAppPage from './pages/MobileAppPage';
import OthersPage from './pages/Others';

// 404 Redirects
import NotFoundLayout from './layouts/404Layout';
import ErrorNotFound from './pages/ErrorPage';


function App() {
  return (
    <div className="App">
      <Switch>
          <Route exact path="/" render={ () => (
          <HomepageLayout>
            <Homepage />
          </HomepageLayout>
        )}
        />

        <Route path="/ptc-sites" render={ () => (
          <MainLayout>
            <MainPage />
          </MainLayout>
        )}
        />

        <Route path="/faucet-sites" render={ () => (
          <MainLayout>
            <FaucetPage />
          </MainLayout>
        )}
        />

        <Route path="/cloudmining-sites" render={ () => (
          <MainLayout>
            <CloudminingPage />
          </MainLayout>
        )}
        />

        <Route path="/trading-sites" render={ () => (
          <MainLayout>
            <TradingPage />
          </MainLayout>
        )}
        />

        <Route path="/mobile-apps" render={ () => (
          <MainLayout>
            <MobileAppPage />
          </MainLayout>
        )}
        />

        <Route path="/others" render={ () => (
          <MainLayout>
            <OthersPage />
          </MainLayout>
        )}
        />

        <Route path="/about" render={ () => (
          <MainLayout>
            <AboutPage />
          </MainLayout>
        )}
        />

        <Route path="/credits" render={ () => (
          <MainLayout>
            <CreditPage />
          </MainLayout>
        )}
        />

        <Route path="*" render={ () => <NotFoundLayout><ErrorNotFound/></NotFoundLayout>} />
        
      </Switch>
    </div>
  );
}

export default App;
